<template>
  <!-- 修改密码 -->
  <div class="changepwd">
    <el-form :model="formData" label-width="150px" ref="formData" :rules="rules">
      <el-form-item label="当前密码："  prop="oldPassword">
        <el-input type="password" v-model="formData.oldPassword"></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="newPassword">
        <el-input type="password" v-model="formData.newPassword"></el-input>
      </el-form-item>
      <el-form-item label="再次输入新密码：" prop="confirmPassword">
        <el-input type="password" v-model="formData.confirmPassword"></el-input>
      </el-form-item>
    
      <el-form-item>
        <el-button @click="updatePassword">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import qs from "qs"
export default {
  data: function() {
    return {
      formData: {
        oldPassword:'',
        newPassword:'',
        confirmPassword:''
      },
      rules:{
        oldPassword:[{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPassword:[{ required: true, message: "请输入新密码", trigger: "blur" }],
        confirmPassword:[{ required: true, message: "请再次输入新密码", trigger: "blur" }]
      }
    };
  },
  methods:{
    logout:async function(){
        var res = await this.$http.post(`/v1/bqUser/logout`);
        var { code, message, data } = res.data;
        if (code == 0) {
          this.$message.success('退出登录');
          this.$router.push('/login')
        } else {
          this.$message.error(message);
        }
    },
    updatePassword:async function(){
      var res = await this.$http.post(`/v1/userInfo/updatePassword`
      ,
      qs.stringify(this.formData)
      )
      var {code,message,data} = res.data
      if(code == 0){
        this.$message.success('修改密码成功，请重新登录！')
        setTimeout(()=>{
          // this.logout();
          this.$store.dispatch('logout');
        },2000)
       
      }else{
        this.$message.error(message);
        
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// @media only screen and (min-width: 1200px) {
  .changepwd .el-row .el-col {
    padding: 0 !important;
  }
  .el-input {
    width: 300px;
  }
// }
</style>



// WEBPACK FOOTER //
// src/components/personalcenter/common/changepwd.vue